import React, { useContext, useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  FormControl,
  Grid,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import SimpleBar from "simplebar-react";
import Countries from "../../../../Contries.json";
import StoreStepperContext from "../../../../context/storeStepperContext";
import { v4 as uuidv4 } from "uuid";
import { collection, getDocs } from "firebase/firestore";
import { db, storage } from "../../../../firebaseConfig";
import FileUploadStoreImages from "../../../../components/common/FileUploadStoreImages";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { useSelector } from "react-redux";

function StoreDetails({ data }) {
  const { storeformData, setStoreFormData } = useContext(StoreStepperContext);
  const [locationData, setLocationData] = useState([]);
  const [selectedValue, setSelectedValue] = useState([]);
  const user = useSelector((state) => state.auth.value);

  const handleChangeTags = (event, newValue) => {
    if (newValue.length <= 2) {
      setSelectedValue(newValue);
      setStoreFormData((prev) => ({
        ...prev,
        storeDesignation: newValue,
      }));
    }
  };

  useEffect(() => {
    const fetchLocationData = async () => {
      try {
        const docRef = collection(db, "countries");
        const querySnapshot = await getDocs(docRef);
        // Extracting data from the querySnapshot
        const countriesData = querySnapshot.docs.map((doc) => ({
          id: doc.id, // Document ID
          ...doc.data(), // Document data
        }));
        setLocationData(countriesData[0]?.locationData);
      } catch (error) {
        console.error("Error fetching location data:", error);
      }
    };

    fetchLocationData();
  }, []);

  const [availableStates, setAvailableStates] = useState([]);
  const [availableCities, setAvailableCities] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState(null);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "storeLocation") {
      const selectedCountry = locationData.find(
        (country) => country.code === value
      );
      setAvailableStates(selectedCountry ? selectedCountry.states : []);
      setAvailableCities([]); // Reset cities when country changes
      setStoreFormData({
        ...storeformData,
        storeLocation: value, // Store country code
        storeState: "",
        storeCity: "",
      });
    } else if (name === "storeState") {
      const selectedState = availableStates.find(
        (state) => state.name === value
      );
      setAvailableCities(selectedState ? selectedState.cities : []);
      setStoreFormData({
        ...storeformData,
        [name]: value,
        storeCity: "",
      });
    } else {
      setStoreFormData({ ...storeformData, [name]: value });
    }
  };

  const uploadImage = async (file) => {
    try {
      // Create a storage reference for the file
      const storageRef = ref(storage, `/store_products/${file.name}`);

      // Upload the file and wait for the snapshot
      const uploadTask = uploadBytesResumable(storageRef, file);
      const snapshot = await uploadTask;

      // Get the downloadable URL
      const photoUrl = await getDownloadURL(snapshot.ref);

      // Return the URL for further processing
      return photoUrl;
    } catch (error) {
      console.error("Error uploading file:", error);
      return null; // Return null for failed uploads
    }
  };

  const onUploadChange = async (fileArray) => {
    setSelectedFiles(fileArray); // Update local state for selected files

    try {
      // Upload files and get URLs in the same order
      const uploadedUrls = await Promise.all(
        fileArray.map((file) => uploadImage(file))
      );

      // Filter out any null entries (failed uploads)
      const validUrls = uploadedUrls.filter((url) => url !== null);

      // Update Firebase and local state
      setStoreFormData((prev) => ({
        ...prev,
        storeImages: validUrls, // Replace with new URLs
      }));
    } catch (error) {
      console.error("Error uploading files:", error);
    }
  };

  return (
    <SimpleBar
      forceVisible="x"
      autoHide={true}
      style={{
        overflowX: "auto",
        maxHeight: "calc(100vh - 310px)",
        minHeight: "calc(100vh - 310px)",
      }}
      className="custom-scrollbar"
    >
      <Box
        sx={{
          width: "50%",
          margin: "0 auto",
          padding: "20px",
          paddingTop: "0px",
          backgroundColor: "white",
        }}
      >
        <Stack direction={"row"} sx={{ marginTop: "20px" }} gap={3}>
          <Grid item>
            <FileUploadStoreImages
              name="images"
              onChange={onUploadChange}
              refresh={selectedFiles}
              typePage="storeDetail"
            />
          </Grid>
        </Stack>

        <Stack sx={{ marginTop: 2 }}>
          <Grid item xs={12} md={6}>
            <Box>
              <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                Name
              </Typography>
            </Box>
            <FormControl
              fullWidth
              sx={{ mt: 1, minWidth: "30vw", minHeight: "35px" }}
              size="small"
            >
              <OutlinedInput
                type="text"
                id="name"
                sx={{ height: "35px" }}
                placeholder="Enter Name"
                name="storeName"
                value={storeformData.storeName}
                onChange={handleChange}
              />
            </FormControl>
          </Grid>
        </Stack>

        <Stack sx={{ marginTop: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Box>
                <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                  Email
                </Typography>
              </Box>
              <FormControl
                fullWidth
                sx={{
                  mt: 1,
                  height: "35px",
                  marginLeft: "0px",
                }}
                size="small"
              >
                <OutlinedInput
                  type="text"
                  id="email"
                  sx={{ height: "35px" }}
                  placeholder="Enter Email Id"
                  name="emailId"
                  value={storeformData.emailId}
                  onChange={handleChange}
                />
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <Box>
                <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                  Contact Person
                </Typography>
              </Box>
              <FormControl
                fullWidth
                sx={{
                  mt: 1,
                  height: "35px",
                  marginLeft: "0px",
                }}
                size="small"
              >
                <OutlinedInput
                  type="text"
                  id="phone"
                  sx={{ height: "35px" }}
                  placeholder="Enter Phone Number"
                  name="phoneNumber"
                  value={storeformData.phoneNumber}
                  onChange={handleChange}
                />
              </FormControl>
            </Grid>
          </Grid>
        </Stack>

        <Stack sx={{ marginTop: 2 }}>
          <Grid item xs={12} md={6}>
            <Box>
              <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                Country
              </Typography>
            </Box>
            <FormControl
              fullWidth
              sx={{ mt: 1, minWidth: "30vw", minHeight: "35px" }}
              size="small"
            >
              <Select
                defaultValue=""
                displayEmpty
                fullWidth
                name="storeLocation"
                sx={{ height: "35px" }}
                value={storeformData.storeLocation}
                onChange={handleChange}
              >
                <MenuItem value="" disabled>
                  Select Country
                </MenuItem>
                {locationData &&
                  locationData?.length > 0 &&
                  locationData.map((country) => (
                    <MenuItem key={country.code} value={country.code}>
                      {country.country}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
        </Stack>

        <Stack sx={{ marginTop: 2 }}>
          <Grid item xs={12} md={6}>
            <Box>
              <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                State
              </Typography>
            </Box>
            <FormControl
              fullWidth
              sx={{
                mt: 1,
                minWidth: "30vw",
                minHeight: "35px",
                marginLeft: "0px",
              }}
              size="small"
            >
              <Select
                displayEmpty
                name="storeState"
                sx={{ height: "35px" }}
                value={storeformData.storeState || ""}
                onChange={handleChange}
                disabled={!availableStates.length}
              >
                <MenuItem value="" disabled>
                  Select State
                </MenuItem>
                {availableStates.map((state) => (
                  <MenuItem key={state.name} value={state.name}>
                    {state.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Stack>

        <Stack sx={{ marginTop: 2 }}>
          <Grid item>
            <Box>
              <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                City
              </Typography>
            </Box>
            <FormControl
              fullWidth
              sx={{
                mt: 1,
                minWidth: "30vw",
                minHeight: "35px",
                marginLeft: "0px",
              }}
              size="small"
            >
              <Select
                displayEmpty
                name="storeCity"
                sx={{ height: "35px" }}
                value={storeformData.storeCity || ""}
                onChange={handleChange}
                disabled={!availableCities.length} // Disable if no cities are available
              >
                <MenuItem value="" disabled>
                  Select City
                </MenuItem>
                {availableCities.map((city) => (
                  <MenuItem key={city} value={city}>
                    {city}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Stack>

        <Stack sx={{ marginTop: 2 }}>
          <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
            Store Designation
          </Typography>
          <Autocomplete
            size="small"
            sx={{ height: "35px", mt: 1 }}
            multiple
            options={["Top picks today", "Top ship"]}
            freeSolo
            value={selectedValue}
            onChange={handleChangeTags}
            renderInput={(params) => (
              <TextField
                sx={{ height: "35px" }}
                {...params}
                placeholder="Search"
                size="small"
              />
            )}
            renderTags={() => null}
          />
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
              marginTop: "8px",
            }}
          >
            {selectedValue.map((tag, index) => (
              <Chip
                sx={{
                  backgroundColor: "rgba(238, 238, 238, 1)",
                  fontSize: "14px",
                  fontWeight: 500,
                  height: "28px",
                }}
                key={index}
                label={tag}
                onDelete={() => {
                  setSelectedValue((prev) =>
                    prev.filter((_, i) => i !== index)
                  );
                }}
              />
            ))}
          </Box>
        </Stack>

        {user?.role !== "Superadmin" && (
          <>
            {" "}
            <Stack sx={{ marginTop: 2 }}>
              <Grid item xs={12} md={6}>
                <Box>
                  <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                    Set Store Currency
                  </Typography>
                </Box>
                <FormControl
                  fullWidth
                  sx={{ mt: 1, minWidth: "30vw", minHeight: "35px" }}
                  size="small"
                >
                  <Select
                    defaultValue=""
                    displayEmpty
                    fullWidth
                    name="storeCurrency"
                    sx={{ height: "35px" }}
                    value={storeformData.storeCurrency}
                    onChange={handleChange}
                  >
                    <MenuItem value="" disabled>
                      Set Store Currency
                    </MenuItem>
                    <MenuItem value="$">$</MenuItem>
                    <MenuItem value="₦">₦</MenuItem>
                    <MenuItem value="₹">₹</MenuItem>
                    <MenuItem value="CFA">CFA</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Stack>
            <Stack sx={{ marginTop: 2 }}>
              <Grid item xs={12} md={6}>
                <Box>
                  <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                    Select Weight
                  </Typography>
                </Box>
                <FormControl
                  fullWidth
                  sx={{ mt: 1, minWidth: "30vw", minHeight: "35px" }}
                  size="small"
                >
                  <Select
                    defaultValue=""
                    displayEmpty
                    fullWidth
                    name="storeWeight"
                    sx={{ height: "35px" }}
                    value={storeformData.storeWeight}
                    onChange={handleChange}
                  >
                    <MenuItem value="" disabled>
                      Select Weight
                    </MenuItem>
                    <MenuItem value="Kg">Kg</MenuItem>
                    <MenuItem value="Lb">Lb</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Stack>
          </>
        )}

        <Stack sx={{ marginTop: 2 }}>
          <Box>
            <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
              Description (limit to 50 words max)
            </Typography>
          </Box>
          <FormControl
            fullWidth
            sx={{
              mt: 1,
              minWidth: "30vw",
              minHeight: "50px",
              marginLeft: "0px",
            }}
            size="small"
          >
            <OutlinedInput
              type="text"
              id="description"
              placeholder="Enter"
              name="storeDescription"
              multiline={true}
              minRows={5}
              maxRows={5}
              inputProps={{ maxLength: 50 }}
              value={storeformData.storeDescription}
              onChange={handleChange}
            />
          </FormControl>
        </Stack>
      </Box>
    </SimpleBar>
  );
}

export default StoreDetails;
